import React from 'react';
import SvgIcon from './SvgIcon';

function NewWindowIcon({ width }) {
    return (
        <SvgIcon className="NewWindowIcon" width={width}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 18 18"
            >
                <g>
                    <path
                        fill="currentColor"
                        d="M3.98 15.375c-.378 0-.699-.131-.961-.394a1.309 1.309 0 01-.394-.962V3.981c0-.38.131-.7.394-.962.262-.263.583-.394.962-.394h4.73V3.75h-4.73a.22.22 0 00-.159.072.22.22 0 00-.072.159v10.038c0 .058.024.11.072.159a.22.22 0 00.159.072h10.038a.22.22 0 00.159-.072.22.22 0 00.072-.159V9.29h1.125v4.73c0 .38-.131.7-.394.962a1.309 1.309 0 01-.962.394H3.981zm3.31-3.874l-.79-.79 6.96-6.961H10.5V2.625h4.875V7.5H14.25V4.54L7.29 11.5z"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

export default NewWindowIcon;
